import { Action } from '@ngrx/store';
import { User } from '@gcv/shared';

export enum UserActionTypes {
  LoadUser = '[User] Load User',
  UserLoaded = '[User] User Loaded',

  UpdateUser = '[User] Update User',
  UserUpdated = '[User] User Updated',

  LoadUserKba = '[User] Load User KBA',
  UserKbaLoaded = '[User] User Kba Loaded',

  VerifyUserKbaAnswers = '[User] Verify User Kba Answers',
  UserKbaAnswersVerified = '[User] User Kba Answers Verified',

  UpdateUserDocuments = '[User] Upload User Documents',

  ResetUserKba = '[User] Reset User Kba',
  ResetUserState = '[User] Reset User State',
}

export class LoadUser implements Action {
  readonly type = UserActionTypes.LoadUser;

  constructor(public payload: { userId: string }) {}
}

export class UpdateUserDocuments implements Action {
  readonly type = UserActionTypes.UpdateUserDocuments;

  constructor(public payload: { userId: string }) {}
}

export class LoadUserKba implements Action {
  readonly type = UserActionTypes.LoadUserKba;

  constructor(public payload: { userId: string }) {}
}

export class UserKbaLoaded implements Action {
  readonly type = UserActionTypes.UserKbaLoaded;

  constructor(public payload: any) {}
}

export class VerifyUserKbaAnswers implements Action {
  readonly type = UserActionTypes.VerifyUserKbaAnswers;

  constructor(public payload: { userId: string; userAnswers: any }) {}
}

export class UserKbaAnswersVerified implements Action {
  readonly type = UserActionTypes.UserKbaAnswersVerified;

  constructor(public payload: User) {}
}

export class UserLoaded implements Action {
  readonly type = UserActionTypes.UserLoaded;

  constructor(public payload: User) {}
}

export class UpdateUser implements Action {
  readonly type = UserActionTypes.UpdateUser;

  constructor(public payload: User) {}
}

export class UserUpdated implements Action {
  readonly type = UserActionTypes.UserUpdated;

  constructor(public payload: User) {}
}

export class ResetUser implements Action {
  readonly type = UserActionTypes.ResetUserState;
}

export class ResetUserKba implements Action {
  readonly type = UserActionTypes.ResetUserKba;
}

export type UserActions =
  | LoadUser
  | UserLoaded
  | UpdateUser
  | UserUpdated
  | ResetUser
  | LoadUserKba
  | VerifyUserKbaAnswers
  | UserKbaLoaded
  | UserKbaAnswersVerified
  | UpdateUserDocuments
  | ResetUserKba;
